import React, { useEffect } from "react";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import { useSelector } from "react-redux";
import BandhanRegistrationCard from "./BandhanRegistrationCard";
import configServ from "../../services/config";
import BandhanRegistrationTable from "./BandhanRegistrationTable";
import Swal from "sweetalert2";

const BandhanRegistrationPage = () => {
  //#region

  const [isCreate, setIsCreate] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [backDrowLoading, setBackDrowLoading] = React.useState(false);
  const [bandhanList, setBandhanList] = React.useState([]);

  //   table
  const [searchType, setSearchType] = React.useState("name");
  const [searchTerm, setSearchTerm] = React.useState("");
  const [dateRange, setDateRange] = React.useState([null, null]);
  const [editData, setEditData] = React.useState(null);
  const [total, setTotal] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);
  const handlePopup = () => {
    setIsCreate(!isCreate);
    setIsEdit(false);
    setEditData(null);
  };

  const fetchBandhan = async () => {
    setBackDrowLoading(true);
    try {
      const res = await configServ.getBandhan({
        page,
        limit: rowsPerPage,
        searchType,
        searchTerm,
        company_id,
      });

      if (res.status) {
        setBandhanList(res.data);
        setTotal(res.total);
      }
    } catch (error) {
      console.log("fetch bandhan list error", error);
      setBandhanList([]);
    } finally {
      setBackDrowLoading(false);
    }
  };
 


  useEffect(() => {
    fetchBandhan();
  }, [page, rowsPerPage, searchType, searchTerm]);

  const handleEdit = (row) => {
    console.log("Edit row:", row);
    setIsEdit(true);
    setIsCreate(true);
    setEditData(row);
    // modal open / state set / api call
  };

  const fetchImag = async (bandhanId) => {
    setBackDrowLoading(true);

    try {
      const res = await configServ.getBandhanImages(bandhanId);
      if (res.status) {
        return res.data; // 👈 data return karo
      }
      return null;
    } catch (error) {
      console.log("error to fetch Imag", error);
      return null;
    } finally {
      setBackDrowLoading(false);
    }
  };
  const handleResetPassword = async (id) => {
    setBackDrowLoading(true);

    try {
      const payload = {
        id: id,
        admin: true,
      };

      const res = await configServ.resetPasswrordBandhanUser(payload);

      if (res?.status === true) {
        Swal.fire({
          icon: "success",
          title: "Password Reset",
          text: res.message || "New password sent to user email",
          confirmButtonColor: "#1976d2",
        });
      } else {
        // 👇 API returned status = false
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: res?.message || "Unable to reset password",
          confirmButtonColor: "#d32f2f",
        });
      }
    } catch (error) {
      console.error("error password reset", error);

      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Something went wrong. Please try again later.",
        confirmButtonColor: "#d32f2f",
      });
    } finally {
      setBackDrowLoading(false);
    }
  };

  //#endregion
  return (
    <>
      <LoaderBackdrop open={backDrowLoading} />
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Bandhan Registration"}
        handlePopup={handlePopup}
        create={isCreate}
        isEdit={isEdit}
      />

      {isCreate && (
        <BandhanRegistrationCard
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          handlePopup={handlePopup}
          editData={editData}
          fetchImag={fetchImag}
          setEditData={setEditData}
          fetchBandhan={fetchBandhan}
        />
      )}
      <BandhanRegistrationTable
        backDrowLoading={backDrowLoading}
        data={bandhanList}
        searchType={searchType}
        setSearchType={setSearchType}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        dateRange={dateRange}
        setDateRange={setDateRange}
        total={total}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        handleEdit={handleEdit}
        fetchImag={fetchImag}
        handleResetPassword={handleResetPassword}
      />
    </>
  );
};

export default BandhanRegistrationPage;
